<template>
  <b-card>
    <h5>{{ labels.publicSurveySettingsTitle }}</h5>
    <b-form-group :label="labels.allowOneSurveyPerDeviceLabel">
      <b-form-checkbox v-model="settings.allowOneSurveyPerDevice" switch />
    </b-form-group>

    <b-form-group :label="labels.allowMultipleSurveysPerDeviceLabel" :disabled="settings.allowOneSurveyPerDevice">
      <b-form-checkbox v-model="settings.allowMultipleSurveysPerDevice" switch :disabled="settings.allowOneSurveyPerDevice" />
    </b-form-group>
    
    <b-form-group :label="labels.allowNextIfErrors">
      <b-form-checkbox v-model="settings.allowNextIfErrors" />
    </b-form-group>

    <b-form-group :label="labels.publicUsersLabel">
        <b-form-input
            v-model="settings.publicUsers"
            :placeholder="labels.publicUsersPlaceholder"
        />
        <b-form-text>{{ labels.publicUsersDescription }}</b-form-text>
    </b-form-group>

    <b-alert type="info" show class="mt-5">
      {{ labels.publicUrlDescription2 }}
    </b-alert>
    <b-form-group :label="labels.publicUrlLabel">
      <b-input-group>
        <b-form-input v-model="settings.publicUrl" />
        <b-input-group-append>
          <b-button @click="copyPublicUrl" :title="labels.copyPublicUrlTitle">
            <i class="mdi mdi-content-copy"></i>
          </b-button>
        </b-input-group-append>
      </b-input-group>
      <b-form-text>{{ labels.publicUrlDescription }}</b-form-text>
    </b-form-group>

    <b-form-group :label="labels.removeDeleteButtonForPublicUser">
      <b-form-checkbox v-model="settings.removeDeleteButtonForPublicUser" />
      <b-form-text>{{ labels.removeDeleteButtonForPublicUserDescription }}</b-form-text>
    </b-form-group>

    <!-- Add more settings as needed based on docs/no_user_survey.md -->

    <b-button variant="primary" @click="saveSettings">{{ labels.saveSettingsButton }}</b-button>
  </b-card>
</template>

<script>
export default {
  name: 'PublicSurvey',
  data() {
    return {
      settings: {
        allowOneSurveyPerDevice: false,
        allowMultipleSurveysPerDevice: true,
        // TODO: One day generate it by system...
        publicUrl: '', // This would likely be generated/retrieved - e.g., from a server
        removeDeleteButtonForPublicUser: false,
      },
    };
  },
  computed: {
    labels() {
      // Fallback to default labels if not found in store, for development
      return this.$store.state.labels.form.formAdminPage ;
    },
  },
  methods: {
    saveSettings() {
      // Implement logic to save settings
      console.log('Saving public survey settings:', this.settings);
      // This would typically involve an API call or a Vuex action
      this.$store.dispatch('form/saveSurvey', this.settings);
    },
    copyPublicUrl() {
      if (this.settings.publicUrl) {
        navigator.clipboard.writeText(this.settings.publicUrl).then(() => {
          this.$store.dispatch('showSuccess', this.labels.urlCopiedSuccess);
        }).catch(err => {
          console.error('Failed to copy URL: ', err);
          this.$store.dispatch('showError', this.labels.urlCopiedError);
        });
      }
    }
  },
  created() {
    // Fetch initial settings if necessary
    this.$store.dispatch('form/getDoc', 'form_config').then(data => Object.assign(this.settings, data));
  }
};
</script>
